// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9af6ed2c","453":"9985181a","455":"07352e3d","977":"a0b87360"}[chunkId] + ".chunk.js";
};